<app-data-table mainTitle="Movimento Lcto Contábil"
            singleTitle="Lançamento Contábil"
            routerPath="/mov-lcto-contabil"
            entityPath="/movlctocontabil"
            keyField="id"
            [entity]="movLctoContabil"
            [columns]="this['columns']"
            [controls]="this['controls']">
</app-data-table>